module.exports = __webpack_public_path__ + "white_logo-7ef73bf24b07f29e16fde73e17858005.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/image_generator/white_logo.png
// module id = 105
// module chunks = 0 1